import springCenfApi from '../../services/springCenfApi'

export const getUnavailableDays = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/unavailable_days', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getUnavailableDay = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/unavailable_days/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeUnavailableDay = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/unavailable_days', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateUnavailableDay = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/unavailable_days/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteUnavailableDay = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/unavailable_days/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)